import { render } from "./Avaluos.vue?vue&type=template&id=637da9de"
import script from "./Avaluos.vue?vue&type=script&lang=js"
export * from "./Avaluos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__